var map = {
	"./NOSE1.svg": 80388,
	"./NOSE10.svg": 22510,
	"./NOSE11.svg": 30222,
	"./NOSE11B.svg": 8954,
	"./NOSE12.svg": 93347,
	"./NOSE2.svg": 46072,
	"./NOSE3.svg": 90114,
	"./NOSE4.svg": 20384,
	"./NOSE5.svg": 78689,
	"./NOSE6.svg": 36295,
	"./NOSE7.svg": 73095,
	"./NOSE8.svg": 95999,
	"./NOSE9.svg": 57493
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 74079;